"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["makes", "make", "className", "onChange"];
var _VehicleMakeSelect_makes;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { uniqBy } from 'lodash';
import { useMemo } from 'react';
import { graphql } from 'react-relay';
import { useFragment } from 'react-relay/hooks';
import { VehicleSelectInput } from '../VehicleSelectInput/VehicleSelectInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const VehicleMakeSelect = _ref => {
  let {
      makes: makesRef,
      make,
      className,
      onChange
    } = _ref,
    inputProps = _objectWithoutProperties(_ref, _excluded);
  const makes = useFragment(_VehicleMakeSelect_makes !== void 0 ? _VehicleMakeSelect_makes : _VehicleMakeSelect_makes = require("../../../relay/__generated__/VehicleMakeSelect_makes.graphql"), makesRef);
  const uniqueMakes = useMemo(() => uniqBy(makes, 'slug'), [makes]);
  return /*#__PURE__*/_jsx(VehicleSelectInput, _objectSpread({
    isLoading: !uniqueMakes || uniqueMakes.length === 0,
    vehicleData: uniqueMakes,
    className: className,
    value: make,
    name: "Make",
    placeholder: "What do you drive?",
    popularOptionsGroupTitle: "Popular Makes",
    nonePopularOptionsGroupTitle: "Other Makes",
    onChange: onChange
  }, inputProps));
};
export default VehicleMakeSelect;